import Icon from '@/assets/icons'
import classnames from 'classnames/bind'
import Link from 'next/link'
import { ComponentProps, HTMLAttributes } from 'react'

import styles from './style.module.scss'

const cx = classnames.bind(styles)

type GoBackButtonProps = Omit<ComponentProps<typeof Link>, 'href'> & {
  wrapperProps?: HTMLAttributes<HTMLDivElement>
  href?: ComponentProps<typeof Link>['href']
}

const GoBackButton = ({ wrapperProps, href = '#', children, onClick, ...props }: GoBackButtonProps) => {
  const { className, ...rest } = wrapperProps || {}

  return (
    <div className={cx('go-back-button', className)} {...rest}>
      <Link href={href} {...props} className={cx('go-back-button__link')} onClick={onClick}>
        <div className={cx('go-back-button__icon')}>
          <Icon.ArrowLeft />
        </div>
        {children}
      </Link>
    </div>
  )
}

export default GoBackButton
